<div class="add-container">
  <h1 class="add-title">Adaugă Configurare</h1>
  <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
    <div class="add-field">
      <mat-form-field appearance="fill">
        <mat-label>Denumire</mat-label>
        <input type="text" matInput formControlName="name" />
        <mat-error
          *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="add-field">
      <mat-form-field appearance="fill">
        <mat-label>Observații</mat-label>
        <input type="text" matInput formControlName="value" />
        <mat-error
          *ngIf="
            !form.controls['value'].valid && form.controls['value'].touched
          "
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
    <div class="add-action-btns">
      <button
        class="buttons"
        type="button"
        mat-flat-button
        (click)="closeDialog()"
      >
        Închide
      </button>
      <button class="buttons" type="submit" mat-flat-button color="primary">
        Salvează
      </button>
    </div>
  </form>
</div>
